import { Component, OnInit } from '@angular/core';
import { JobService } from 'app/jobService';

@Component({
  selector: 'navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss']
})
export class NavigationBarComponent implements OnInit {

  index1: boolean;
  index2: boolean;
  index3: boolean;
  index4: boolean;
  index5: boolean;
  index6: boolean;

  constructor(private js: JobService) {

  }

  ngOnInit() {
    if (this.js.navigate == 1) {
      this.index1 = true;
      this.index2 = false;
      this.index3 = false;
      this.index4 = false;
      this.index5 = false;
      this.index6 = false;
    } else if (this.js.navigate == 2) {
      this.index1 = false;
      this.index2 = true;
      this.index3 = false;
      this.index4 = false;
      this.index5 = false;
      this.index6 = false;
    } else if (this.js.navigate == 3) {
      this.index1 = false;
      this.index2 = false;
      this.index3 = true;
      this.index4 = false;
      this.index5 = false;
      this.index6 = false;
    } else if (this.js.navigate == 4) {
      this.index1 = false;
      this.index2 = false;
      this.index3 = false;
      this.index4 = true;
      this.index5 = false;
      this.index6 = false;
    }else if (this.js.navigate == 5) {
      this.index1 = false;
      this.index2 = false;
      this.index3 = false;
      this.index4 = false;
      this.index5 = true;
      this.index6 = false;
    }else if (this.js.navigate == 6) {
      this.index1 = false;
      this.index2 = false;
      this.index3 = false;
      this.index4 = false;
      this.index5 = false;
      this.index6 = true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/navigation-bar/navigation-bar.component.ts